import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import type {Document} from '@contentful/rich-text-types'
import {Card} from '@primer/react-brand'

import {getAnalyticsEvent} from '../../../../lib/utils/analytics'
import {getFallbackImageUrl} from '../../utils/fallback-images'

export type ResourceCardProps = {
  resource: ResourceSummary
  index?: number
  colorMode?: 'light' | 'dark'
}

export interface ResourceSummary {
  heading?: string | null
  image?: {
    description?: string | null
    url?: string | null
  } | null
  path?: string | null
  description?: Document | null
}

export const ResourceCard = ({resource, index = 0, colorMode}: ResourceCardProps) => {
  if (!resource.path || !resource.heading) return null

  const imageUrl = resource.image?.url || getFallbackImageUrl(index, colorMode)
  const imageAlt = resource.image?.description || ''

  return (
    <Card
      href={resource.path}
      {...getAnalyticsEvent({
        action: 'learn more',
        tag: 'card',
        context: resource.heading,
      })}
    >
      <Card.Image src={imageUrl} alt={imageAlt} />

      <Card.Heading>{resource.heading}</Card.Heading>

      {resource.description && <Card.Description>{documentToReactComponents(resource.description)}</Card.Description>}
    </Card>
  )
}

try{ ResourceCard.displayName ||= 'ResourceCard' } catch {}